<template>
  <div class="card conteiner">
    <search id="searchComponent" class="mb-4" @getFilter="getFilter"></search>

    <nav>
        <ul class="nav nav-tabs" id="nav-tab" role="tablist">
            <li class="nav-item">
                <a v-if="pujas[1]" class="nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-activa" role="tab" aria-controls="nav-home" aria-selected="true"><i class="fas fa-lock-open"></i> Activas</a>
            </li>
            <li class="nav-item">
                <a v-if="pujas[2]" class="nav-link" id="nav-finalizada-tab" data-toggle="tab" href="#nav-finalizada" role="tab" aria-controls="nav-profile" aria-selected="false"><i class="fas fa-lock"></i> Finalizadas</a>
            </li>
            <li class="nav-item">
                <a v-if="pujas[3]" class="nav-item nav-link" id="nav-compra-tab" data-toggle="tab" href="#nav-compra" role="tab" aria-controls="nav-compra" aria-selected="false"><i class="fas fa-shopping-bag"></i> En proceso de compra</a>
            </li>            
        </ul>
    </nav>
    <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active" id="nav-activa" role="tabpanel" aria-labelledby="nav-activa-tab">
            <div class="card-body">
                <div class="row p-2">
                    <div class="col-6 h4 mb-1 font-weight-bold">Ofertas Activas</div>
                    <div v-if="this.estado_id != 0" class="col-6 mt-3 text-nowrap text-right">
                        <button type="button"  @click="$router.back()" class="btn btn-primary mb-1 text-right">
                            <i class="fas fa-arrow-left pr-1"></i>
                            Volver
                        </button> 
                    </div>
                </div>
    
                <div class="table-responsive">  
                    <table ref="tabla_contenedora_a" class="table table-striped table-hover table-bordered">
                        <caption>Listado de ofertas</caption>
                        <thead>
                            <tr>
                                <th scope="col">Título</th>
                                <!--th scope="col">Categoría</th-->
                                <th scope="col">Tiempo</th>
                                <th scope="col">Fecha Inicial</th>
                                <th scope="col">Fecha Final</th>
                                <th scope="col">Estado</th>
                                <!--th scope="col">Dirección</th -->
                                <th scope="col">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(puja, index) in pujas[1]" v-bind:value="puja.id" :key="index">
                                <td>{{puja.title}}</td>
                                <!--td>{{puja.category_path}}</td-->
                                <td>{{puja.tiempo}}</td>
                                <td>{{puja.date_inii}}</td>
                                <td>{{puja.date_fini}}</td>
                                <td>{{puja.estado}}</td>
                                <!-- td>{{puja.direccion}}</td -->
                                <td class="text-center text-nowrap">
                                    <a :href="$router.resolve({ name: 'puja', params: { id: puja.id } }).href"
                                    class="btn btn-outline-primary btn-block"
                                    >
                                    <i class="fas fa-eye text-primary pr-1"></i>
                                    Ver Detalle 
                                    </a>                   
                                </td>
                            </tr>
                        </tbody>
                    </table>        
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="nav-finalizada" role="tabpanel" aria-labelledby="nav-finalizada-tab">
            <div class="card-body">
                <div class="row p-2">
                    <div class="col-6 h4 mb-1 font-weight-bold">Ofertas Finalizadas</div>
                    <div v-if="this.estado_id != 0" class="col-6 mt-3 text-nowrap text-right">
                        <button type="button"  @click="$router.back()" class="btn btn-primary mb-1 text-right">
                            <i class="fas fa-arrow-left pr-1"></i>
                            Volver
                        </button> 
                    </div>
                </div>
    
                <div class="table-responsive">  
                    <table ref="tabla_contenedora_f" class="table table-striped table-hover table-bordered">
                        <caption>Listado de ofertas</caption>
                        <thead>
                            <tr>
                                <th scope="col">Título</th>
                                <!--th scope="col">Categoría</th-->
                                <th scope="col">Tiempo</th>
                                <th scope="col">Fecha Inicial</th>
                                <th scope="col">Fecha Final</th>
                                <th scope="col">Estado</th>
                                <!--th scope="col">Dirección</th -->
                                <th scope="col">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(puja, index) in pujas[2]" v-bind:value="puja.id" :key="index">
                                <td>{{puja.title}}</td>
                                <!--td>{{puja.category_path}}</td-->
                                <td>{{puja.tiempo}}</td>
                                <td>{{puja.date_inii}}</td>
                                <td>{{puja.date_fini}}</td>
                                <td>{{puja.estado}}</td>
                                <!-- td>{{puja.direccion}}</td -->
                                <td class="text-center text-nowrap">
                                    <a :href="$router.resolve({ name: 'puja', params: { id: puja.id } }).href"
                                    class="btn btn-outline-primary btn-block"
                                    >
                                    <i class="fas fa-eye text-primary pr-1"></i>
                                    Ver Detalle 
                                    </a>                   
                                </td>
                            </tr>
                        </tbody>
                    </table>        
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="nav-compra" role="tabpanel" aria-labelledby="nav-compra-tab">
            <div class="card-body">
                <div class="row p-2">
                    <div class="col-6 h4 mb-1 font-weight-bold">Ofertas en proceso de compra</div>
                    <div v-if="this.estado_id != 0" class="col-6 mt-3 text-nowrap text-right">
                        <button type="button"  @click="$router.back()" class="btn btn-primary mb-1 text-right">
                            <i class="fas fa-arrow-left pr-1"></i>
                            Volver
                        </button> 
                    </div>
                </div>
    
                <div class="table-responsive">  
                    <table ref="tabla_contenedora_c" class="table table-striped table-hover table-bordered">
                        <caption>Listado de ofertas</caption>
                        <thead>
                            <tr>
                                <th scope="col">Título</th>
                                <!--th scope="col">Categoría</th-->
                                <th scope="col">Tiempo</th>
                                <th scope="col">Fecha Inicial</th>
                                <th scope="col">Fecha Final</th>
                                <th scope="col">Estado</th>
                                <!--th scope="col">Dirección</th -->
                                <th scope="col">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(puja, index) in pujas[3]" v-bind:value="puja.id" :key="index">
                                <td>{{puja.title}}</td>
                                <!--td>{{puja.category_path}}</td-->
                                <td>{{puja.tiempo}}</td>
                                <td>{{puja.date_inii}}</td>
                                <td>{{puja.date_fini}}</td>
                                <td>{{puja.estado}}</td>
                                <!-- td>{{puja.direccion}}</td -->
                                <td class="text-center text-nowrap">
                                    <a :href="$router.resolve({ name: 'puja', params: { id: puja.id } }).href"
                                    class="btn btn-outline-primary btn-block"
                                    >
                                    <i class="fas fa-eye text-primary pr-1"></i>
                                    Ver Detalle 
                                    </a>                   
                                </td>
                            </tr>
                        </tbody>
                    </table>        
                </div>
            </div>
        </div>
    </div>


  </div>
</template>
<script>
import SearchComponentVue from "./SearchComponent.vue";
export default {
    components:{
        SearchComponentVue
    },
    props:['url','post_id','estado_id'],
    data: function () {
        return {
            postSelected: "",
            pujas: [],
            total: 0,
            currentPage: 1,
            dataLoaded: false
        };
    },
    mounted() {
        this.loadPost();
    },
    updated(){
        if (this.dataLoaded) {
            this.$nextTick(() => {
                this.initializeDataTables();
            });
        }        
        if (this.estado_id > 0){
             $('#nav-tab li:nth-child('+this.estado_id+') a').tab('show') // Select first tab$('#myTab li:nth-child(3) a').tab('show')
        }
        else{
            if (typeof this.pujas[1] === 'object'){
                $('#nav-tab li:nth-child(1) a').tab('show') // Select first tab$('#myTab li:nth-child(3) a').tab('show')
            }
            else if (!this.pujas[1] && typeof this.pujas[2] === 'object'){
                $('#nav-tab li:nth-child(2) a').tab('show');
            }            
            else if (!this.pujas[1] && !this.pujas[2] && typeof this.pujas[3] === 'object'){
                $('#nav-tab li:nth-child(3) a').tab('show');
            }
        }
    },
    methods: {
        loadPost() {
            if (this.post_id > 0){
                axios.get('/api/postpujas/'+this.post_id+'/'+this.estado_id).then((response) => {
                    this.pujas = response.data;
                    this.dataLoaded = true;
                });
            }else{
                axios.get('/api/pujas').then((response) => {
                    this.pujas = response.data;
                    this.dataLoaded =  true;
                }); 
            }
                       
        },
        initializeDataTables(){
            $(this.$refs.tabla_contenedora_a).DataTable({
                "language": {
                        url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
                    },
                    dom: 'lftip',
                    pageLength: 10,
                    order: [
                        [3, 'desc'],
                    ],
                    columnDefs: [{
                            targets: [5],
                            orderable: false
                        } // Columnas 0 (ID) y 2 (Correo) no son ordenables
                    ]
            });

            $(this.$refs.tabla_contenedora_f).DataTable({
                "language": {
                        url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
                    },
                    dom: 'lftip',
                    pageLength: 10,
                    order: [
                        [3, 'desc'],
                    ],
                    columnDefs: [{
                            targets: [5],
                            orderable: false
                        } // Columnas 0 (ID) y 2 (Correo) no son ordenables
                    ]
            });

            $(this.$refs.tabla_contenedora_c).DataTable({
                "language": {
                        url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
                    },
                    dom: 'lftip',
                    pageLength: 10,
                    order: [
                        [3, 'desc'],
                    ],
                    columnDefs: [{
                            targets: [5],
                            orderable: false
                        } // Columnas 0 (ID) y 2 (Correo) no son ordenables
                    ]                    
            });

            this.dataLoaded = false;
        },
        getFilter(data){
            if(data == ''){
                data='Titulo: ';
            }
            let data_url = 'find';
            fetch("/api/post_filter/"+ data_url +"/?page=" + this.currentPage +"&filtro=" + data +'&orden=' + this.orden)
                    .then((response) => response.json())
                    .then((json) => {
                    this.posts = json.data.data;
                    this.total = json.data.last_page;
                    });
        }
    }
};
</script>